<template>
  <div >
<!--    <el-tabs v-model="listQuery.videoCategoryId" stretch="true" @tab-click="handleTabClick">-->
<!--      <el-tab-pane v-for="item in tabs" :label="item.name" :name="item.categoryId" :key="item.categoryId" >-->
<!--      </el-tab-pane>-->
<!--    </el-tabs>-->
    <div >
      <h2 class="module-title">
        基础理论
      </h2>
<!--      <small class="title-small">-->
<!--        basic theory-->
<!--      </small>-->
    </div>
    <div class="course-tool-bar">
      <div class="redio-button">
        <el-row>
          <el-button type="info" plain autofocus="true" size="mini" round @click="queryCategory()">综合</el-button>
          <el-button type="info" plain  size="mini"  round @click="queryCategory(2)">最新</el-button>
          <el-button type="info" plain size="mini" round @click="queryCategory(1)">最热</el-button>
        </el-row>
      </div>
      <div class="course-pagination">
        <div style="display: inline-block">
          <solt>
<!--            <div style="float: end">-->
<!--               {{listQuery.page}}/{{Math.ceil(total/listQuery.limit)}}-->
<!--            </div>-->
          </solt>
        </div>
        <div style="display: inline-block">
          <el-pagination
            :total="total"
            layout="prev,pager, next, slot"
            pager-count="3"
            :current-page.sync="listQuery.page"
            :page-size.sync="listQuery.limit"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-row>
      <el-col  :span="6" v-for="item in list" :key="item.id"  :offset="index > 0 ? 0 : 0">

          <el-card   shadow='hover' :body-style="{ padding: '0px'} ">
               <a href="javascript:void(0);"  @click="goVideoDetail(item.id,item.ifCharge,item.content,item.type)">
                <img :src="baseUrl+item.picUrl" class="image">
               </a>
            <div style="padding: 14px 5px;">
              <el-link   :underline="false" target="_blank" class="title" @click="goVideoDetail(item.id,item.ifCharge,item.content)">{{item.title}}</el-link>
              <div class="home-pay-title">主讲老师：{{item.userName}}</div>

              <div class="bottom clearfix">

                <div>
                  <span class="charge" v-if="item.ifCharge === 0">免费</span>
                  <span class="charge" v-if="item.ifCharge === 1">￥{{item.charge}}</span>
                  <span class="time">
                  <i class="iconfont icondianzan">{{item.countLike}}</i>
                </span>
                  <span class="time">
                  <i class="iconfont iconyunhang">{{item.countPlay}}</i>
                </span>
                </div>
              </div>
            </div>
          </el-card>

      </el-col>
    </el-row>
    <div>
      <h2 class="module-title">
        学术论文
      </h2>
    </div>
    <div>
      <el-row>
        <el-col  :span="6" v-for="item in module1" :key="item.id"  :offset="index > 0 ? 0 : 0">

          <el-card   shadow='hover' :body-style="{ padding: '0px'} ">
            <a href="javascript:void(0);"  @click="goVideoDetail(item.id,item.ifCharge,item.content,item.type)">
              <img :src="baseUrl+item.picUrl" class="image">
            </a>
            <div style="padding: 14px 5px;">
              <el-link   :underline="false" target="_blank" class="title" @click="goVideoDetail(item.id,item.ifCharge,item.content)">{{item.title}}</el-link>
              <div class="home-pay-title">主讲老师：{{item.userName}}</div>

              <div class="bottom clearfix">

                <div>
                  <span class="charge" v-if="item.ifCharge === 0">免费</span>
                  <span class="charge" v-if="item.ifCharge === 1">￥{{item.charge}}</span>
                  <span class="time">
                  <i class="iconfont icondianzan">{{item.countLike}}</i>
                </span>
                  <span class="time">
                  <i class="iconfont iconyunhang">{{item.countPlay}}</i>
                </span>
                </div>
              </div>
            </div>
          </el-card>

        </el-col>
      </el-row>
    </div>
    <div>
      <h2 class="module-title">
        政策解读
      </h2>
    </div>
    <!-- 政策解读 -->
    <div class="unscramblePolicy">
      <div class="policy-left xm9 xs12">
        <div class="message-list policyList">

          <a class="flex itemCenter space-between" v-for="item in policyTypeList"
             @click="getMoreDetail(item.newsTypeId,item.id)">
            <img src="../../assets/b100y/img/square.png" alt="" />
            <span>{{item.newsMainTitle}}</span>
            <span>{{item.gmtModify}}</span>
          </a>

        </div>
        <p class="morePolicy morePolicyList" @click="morePolicy('政策解读',2)">更多+</p>
      </div>
    </div>
    <!-- 政策解读 -->
    <div>
      <h2 class="module-title" @click="morePolicy('专家观点',9)">
        专家观点
      </h2>
    </div>
    <!--专家观点-->
    <div class="experts-interview-wrapper flex" id="expert">
      <!--专家观点8-->
      <div class="experts-view-wrapper x7">
        <div class="side-interview-wrap">
          <div class="side-interview flex" v-for="item in interView"
               @click="getMoreDetail(9,item.id)">
            <div class="main-interview-left">
              <img :src="item.newsImgUrl" alt="专家观点" class="img-responsive"
                   v-if="item.newsImgUrl !== ''" />
              <img src="img/default.jpg" alt="" v-else />
            </div>
            <div class="main-interview-right flex1">
              <h3 class="f20 ellipsis">{{item.newsMainTitle}}</h3>
              <p class="f12" v-html="removeLabel(item.newsContent)"></p>
            </div>

          </div>
        </div>
      </div>
      <!--专家观点end-->
      <!--热门访谈end-->
    </div>

    <!--会议论坛-->
    <div>
      <h2 class="module-title" @click="morePolicy('会议论坛',6)">
        会议论坛
      </h2>
    </div>
    <div class="meeting-forum-wrapper" id="meeting">

      <div class="meeting-forun-wrap flex">
        <ul class="meeting-forun-right">
          <li class="meeting-item flex itemCenter" v-for="item in meeting"
              @click="getMoreDetail(14,item.id)">
            <img src="../../assets/b100y/img/square.png" />
            <p class="f14">{{item.newsMainTitle}}</p>
            <span class="time-right">{{item.gmtModify}}</span>
          </li>

        </ul>
      </div>

      <div class="meeting-infor-wrapper flex">
        <div class="infor-item" v-for="item in bottomMeeting" @click="getMoreDetail(15,item.id)">
          <img :src="item.newsImgUrl" alt="会议论坛" v-if="item.newsImgUrl !== ''" />
          <img src="img/default.jpg" alt="" v-else="" />
          <p class="f12 ellipsis-2">{{item.newsMainTitle}}</p>

        </div>
      </div>
    </div>
    <!--会议论坛end-->
    <!--专家观点end-->
  </div>

</template>

<script>
  import {getVideoList,getVideoCategory} from '@/api/index'
  import {verifyIfBuy,verifyInfo} from '@/api/videoDetail'
  import store from '@/store'
  import axios from 'axios'

    export default {
      name: "index",
      props:["titleSearch"],
      data() {
        return {
          activeName: '',
          tabs:[],
          // baseUrl:'http://localhost:8100/helen/',
          list: [],
          module1:[],
          total: 50,
          listLoading: true,
          listQuery: {
            page: 1,
            limit: 16,
            title: null,
            videoCategoryId: null,
            category: null
          },
          policyTypeList: [],
          base: "//api.wy56.com/yuanqu-api/v001/",
          hotPolicy: [],
          tab: 0,
          typeId: null,
          typeName: null,

          interView: [],
          hotInterView: [], //热门访谈前3个
          hotInterList: [],
          goodLesson: [],
          newLesson: [],
          expertInterView: [], //专家观点大图
          meeting: [], //会议论坛右边信息
          hotMeeting: [], //会议论坛热点
          bottomMeeting: [], // 会议论坛底部数据


          booksList: [], //书本列表
          toShopUrl: '', //购买途径
          hasQrCode: false,  //购买二维码显示
          accordion: false
        };
      },
      mounted() {
        this.accordion = this.getQueryVariable('accordion')
      },
      created() {
        this.getVideoCategory()
        this.getVideoList()
        this.getModule1List()
        //政策解读
        this.getHotPolicy();
        //获取热门解读
        this.getPolicyList();
        this.getCatalogs();
        this.getMeeting();
        this.getBottomMeeting();


      },
      methods: {
        //会议论坛\n
        getMeeting() {
          var that = this;
          axios.get(this.base + 'baiyi/newsitem/getItemsByTypeId',{
            params:{
              typeId: 14,
              page: 1,
              pageSize: 10,
            }
          }).then(function (res) {
            res = res.data
            if (res.code == 2000000) {
              //							console.log(res.data)
              that.meeting = res.data.list;
              that.hotMeeting = that.meeting[0];
              that.meeting.forEach(function (item, i) {
                item.gmtModify = item.gmtModify.substring(0, 10);
              })
            }
          })
        },

        getBottomMeeting() {
          var that = this;
          axios.get(this.base + 'baiyi/newsitem/getItemsByTypeId',{
            params:{
              typeId: 15,
              page: 1,
              pageSize: 4,
            }
          }).then(function (res) {
            res = res.data
            if (res.code == 2000000) {
              that.bottomMeeting = res.data.list;
            }
          })
        },
        removeLabel(label) {
          //原本返回富文本信息，但需求是不需要显示图片，样式要统一，所以只能去掉<>标签
          var html = '';
          var reg = /<[^<>]+>/g;
          html = label.replace(reg, '');
          return html;
        },
        //百驿访谈
        getCatalogs() {
          var that = this;
          axios.get(this.base + 'baiyi/newsitem/getItemsByTypeId',{
            params:{
              typeId: 9,
              page: 1,
              pageSize: 4,
            }
          }).then(function (res) {
            res = res.data
              if (res.code == 2000000) {
                var data = res.data.list;
                that.interView = data;
              }

          })
        },
        //跳转到更多政策
        morePolicy(mainTitle,typeId) {
          window.location.href = '//www.b100y.com/'+'policy.html?origin=home&mainTitle=' + escape(mainTitle) + '&typeId='+typeId;
        },
        //获取热门解读
        getPolicyList() {

          var that = this;
          axios.get(this.base + 'baiyi/newsitem/getItemsByTypeId',{
            params:{
              typeId: 8,
              page: 1,
              pageSize: 6,
            }
          }).then(function (res) {
            res = res.data
            console.log(res)
            if (res.code == 2000000) {
              that.hotPolicy = res.data.list;
            }
          })


        },
        getQueryVariable: function (variable) {
          var query = window.location.search.substring(1);
          var vars = query.split("&");
          for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
          }
          return false
        },
        //查看更多详情政策
        getMoreDetail(type, id) {

          if (type == undefined) {
            type = this.typeId;
          }
          window.location.href = '//www.b100y.com/'+'newsDetail.html?tab=2&type=' + type + '&id=' + id;
        },
        getHotPolicy() {
          var that = this;

          axios.get(this.base + 'baiyi/newstype/getTypesAndNews',{
            params:{
              catalogId: 2
            }
          }).then(function (res) {
            res = res.data
            if (res.code == 2000000) {

              var data1 = res.data.types[0].items;
              var data2 = res.data.types[1].items;
              that.policyTypeList = data1.concat(data2);//c=[1,2,3,4,5,6];
              that.policyTypeList.forEach(function (item, i) {
                item.gmtModify = item.gmtModify.substring(0, 10);
              })
            }
          })
        },


        getVideoList() {
          getVideoList(this.listQuery).then(res => {
            if(res.code===20000){
              this.total = res.data.total
              this.list = res.data.list
            }
          })

        },
        getModule1List() {
          const param={
            page: 1,
            limit: 4,
            title: null,
            videoCategoryId: 2,
            category: null
          }
          getVideoList(param).then(res => {
            if(res.code===20000){
              // this.total = res.data.total
              this.module1 = res.data.list
            }
          })
        },
        getVideoCategory(){
          getVideoCategory().then(res=>{
            if(res.code===20000){
              this.tabs = res.data
              this.tabs.unshift({
                "id": '',
                "name": "全部",
                "categoryId": '',
                "description": "全部"
              })
            }
          })
        },
        handleCurrentChange(val){
          this.listQuery.page= val
          this.getVideoList(this.listQuery)
        },
        queryCategory(val){
          this.listQuery.category= val
          this.getVideoList(this.listQuery)
        },
        handleTabClick(tab, event){
           this.getVideoList(this.listQuery)
        },
        goVideoDetail(id,ifCharge,content,type) {

          if (store.getters.token) {
          if (ifCharge === 0) {
            verifyInfo(id).then(res=>{
              if (res.data!==0) {
                if (type === 1) {
                  this.$router.push({name: 'VideoDetail', params: {id: id}})
                } else {
                  this.$router.push({name: 'Article', params: {id: id}})
                }
              }else{
                this.$message({
                  message: '积分不足',
                  type: 'warning'
                });
              }

            })

          } else {
            if (store.getters.token) {
              verifyIfBuy(id).then(res => {
                if (res.data === true) {
                  if (type === 1) {
                    this.$router.push({name: 'VideoDetail', params: {id: id}})
                  } else {
                    this.$router.push({name: 'Article', params: {id: id}})
                  }
                } else if (res.data === null) {
                  this.$router.push({name: 'Order', params: {id: id}})
                } else if (res.data !== null) {
                  this.$router.push({name: 'Pay', params: {id: res.data.orderNum}})
                }
              })
            } else {
              this.$router.push({name: 'Login'})
            }
          }
        }else {
            this.$router.push({name: 'Login'})
          }
        }
      },
      watch:{
        titleSearch:function(newVal,oldVal) {
          this.listQuery.title=1
          this.listQuery.title=newVal
          this.getVideoList()
        }
      }

    }
</script>

<style scoped>
@import "../../assets/icon/iconfont.css";
@import "../../assets/b100y/byCollege.css";
@import "../../assets/b100y/common.css";
/*@import "../../assets/b100y/pintuer.css";*/
/*@import "../../assets/b100y/reset.css";*/
.iconfont{
  font-size: 13px;
  color: #999;

}
.time-right{
  float: right;
}
.unscramblePolicy{
  text-align: left;
}
  .time {
    font-size: 13px;
    margin: 0px 2px;
  }
  .charge {
    font-size: 13px;
    margin: 0px 2px;
    font-weight: bold;
    color: #f01414;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
    height: 146px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }
  .el-col {
    padding: 10px;
  }
  .el-card{
    /*width: 235px;*/
    margin: auto;
    text-align: left;
  }
  .title{

    font-family: "微软雅黑 Light";
    font-weight: bold;
  }
[class^="el-icon-"], [class*=" el-icon-"] {
  font-size: 13px;
  font-style: normal;
  color: #999;
}
  .el-row{
    text-align: left;
  }
  .course-tool-bar{
    padding: 6px 10px;
    text-align: left;
  }
  .redio-button{

    display: inline-block;
  }
  .course-pagination{
    display: inline-block;
    float: right;
  }
  .home-pay-title{
    margin: 10px 7px 10px 0px;
    color: #333;
    line-height: 1.2;
    font-size: small !important;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    font-family: "Microsoft YaHei", "simsun", "Helvetica Neue", Arial, Helvetica, sans-serif;
  }

.home-pay-subtitle {
  margin-bottom: .5em;
  overflow: hidden;
  line-height: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 7px;
  color: #999;
  font-family: 'microsoft yahei',sans-serif !important;
}
  .module-title{
    text-align: left;
    padding: 20px 10px 5px 10px;
    font-weight: bold;
    font-size: 25px;
  }
  .title-small{
    color: #999;
    font-size: 20px;
  }
  .side-interview-wrap{
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs/index.vue